"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateMachineService = void 0;

var _xstate = require("xstate");

var _visData = require("vis-data");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var is = require("is_js");

var StateMachineService = /*#__PURE__*/function () {
  function StateMachineService() {
    _classCallCheck(this, StateMachineService);

    _defineProperty(this, "db", void 0);

    this.db = new _visData.DataSet();
  }

  _createClass(StateMachineService, [{
    key: "createMachine",
    value: function createMachine(params, services) {
      if (is.not.existy(params) || is.empty(params)) {
        throw Error("params cannot be null or empty");
      }

      var machine = (0, _xstate.createMachine)(params, {
        services: services,
        actions: {
          successAction: (0, _xstate.assign)(function (context, event) {
            var _event$data, _event$data3;

            if (context[event === null || event === void 0 ? void 0 : (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.key]) {
              var _event$data2;

              return _defineProperty({}, event.data.key, _objectSpread(_objectSpread({}, context[event.data.key]), {}, {
                payload: event === null || event === void 0 ? void 0 : (_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.value
              }));
            }

            return {
              payload: event === null || event === void 0 ? void 0 : (_event$data3 = event.data) === null || _event$data3 === void 0 ? void 0 : _event$data3.value
            };
          }),
          failureAction: (0, _xstate.assign)(function (context, event) {
            var _event$data4;

            if (context[event === null || event === void 0 ? void 0 : (_event$data4 = event.data) === null || _event$data4 === void 0 ? void 0 : _event$data4.key]) {
              var _event$data5;

              return _defineProperty({}, event.data.key, _objectSpread(_objectSpread({}, context[event.data.key]), {}, {
                payload: event === null || event === void 0 ? void 0 : (_event$data5 = event.data) === null || _event$data5 === void 0 ? void 0 : _event$data5.value
              }));
            } else {
              var _event$data6;

              return {
                payload: event === null || event === void 0 ? void 0 : (_event$data6 = event.data) === null || _event$data6 === void 0 ? void 0 : _event$data6.value
              };
            }
          })
        }
      });

      try {
        this.db.update({
          id: params.id,
          machine: machine
        });
      } catch (error) {
        if (error.message.includes("Duplicate key for property id")) ;
        var res = this.findMachine(params.id);
        return res === null || res === void 0 ? void 0 : res.machine;
      }

      return machine;
    }
  }, {
    key: "findMachine",
    value: function findMachine(id) {
      try {
        var res = this.db.get(id);
        return res;
      } catch (err) {
        // console.log("error in finding machine", err);
        throw Error("error in finding machine ".concat(id));
      }
    }
  }, {
    key: "deleteMachine",
    value: function deleteMachine(id) {
      try {
        this.db.remove(id);
      } catch (err) {
        throw Error("error in deleting machine ".concat(id));
      }
    }
  }, {
    key: "mutateObjectProperty",
    value: function mutateObjectProperty(prop, value, obj) {
      var _this = this;

      return obj.constructor === Object && Object.keys(obj).forEach(function (key) {
        if (key === prop) obj[key] = value;

        _this.mutateObjectProperty(prop, value, obj[key]);
      });
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new StateMachineService();
      }

      return this.instance;
    }
  }]);

  return StateMachineService;
}();

exports.StateMachineService = StateMachineService;

_defineProperty(StateMachineService, "instance", void 0);